module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo2-ef32d16932faf563ffa3e954c78f4a87.png";